const basic = {
    ru: {
        button: {
            validate: "Подвердить",
            create: "Создать",
            edit: "Изменить",
            delete: "Удалить",
            options: "Опции",
            cancel: "отменить",
            true: "Да",
            false: "Нет",
            ok: "ОК",
            upload: "Отправить файл",
            close: "Закрить",
            reset: "RAZ",
            yes: "Да",
            no: "Нет",
            move: "перейти",
            sick: "болезнь",
            read: "см"
        },
        navbar: {
            newBuilding: "новое здание",
            newCow: "новая корова",
            newBull: "новый бык",
        },
        field: {
            search: null
        },
        table: {
            state: "Статус",
            type: "Тип",
            buckle: "№",
            age: "Возраст",
            building: "Здание",
            milk: "Молоко",
            calving: "Отёль",
            insemination: "Осеменение",
            action: "Действие",
            by: "Кто",
            for: "В течение",
            ultrasound: "УЗИ",
            date: "Дата",
            detail: "Деталь",
            lactation: "Лактация",
            lastState: "Последний статус",
            sicknesses: "заболевания"
        },
        route: {
            dashboard: "Приборная панель",
            fecondity: "фертильность",
            cattle: "Стадо",
            bull: "тавро",
            milkInspection: "Контрольная дойка",
            buildings: "Здание",
            animals: "Животныж",
            insemination: "Воспроизвство",
            log: "Журнал",
            summary: "Резюме",
            culled: "Брак"
        },
        animal: {
            type: {
                calf: "Бычки",
                heifer: "Тиолки",
                cow: "Коров",
                bull: "Бык"
            },
            state: {
                ultrasound: "УЗИ",
                calving: "Отёль",
                calved: "После отела",
                inseminated: "Стельная",
                inseminate: "Опоздание",
                insemination: "Осемененные",
                'non-inseminated': "Холостая",
                cull: "Брак",
                culled: "Брак",
                'to-dry-up': "Запуск",
                dried: "Сухостой",
                dead: "Мертвая",
                milkInspection: "Контрольная дойка",
                hot: "В охоте",
                nothing: "Тёлочка",
                empty: "Холостая",
                unknown: "???",
                abortion: "Аборт",
                stillbirth: "Мёртворождёное",
                'abortion-dead': "Аборт и мертвая мать",
                'stillbirth-dead': "Мёртворождёное и мертвая мать",
                'abortion-but': "Аборт в сухой период",
                pregnant: "Стельная",
                monitor: "После ИО",
                error: "Erreur",
                sold: "Проданный"
            }
        }
    },
    fr: {
        button: {
            validate: "Valider",
            create: "Créer",
            edit: "Modifier",
            delete: "Supprimer",
            options: "Options",
            cancel: "Annuler",
            true: "Oui",
            false: "Non",
            ok: "Ok",
            upload: "Envoyer fichier",
            close: "Fermer",
            reset: "RAZ",
            yes: "Oui",
            no: "No",
            move: "Déplacer",
            sick: "Maladies",
            read: "Voir"
        },
        navbar: {
            newBuilding: "Nouveau bâtiments",
            newCow: "Nouvelle vache",
            newBull: "Nouveau taureau",
        },
        field: {
            search: "Rechercher"
        },
        table: {
            state: "état",
            type: "Type",
            buckle: "Boucle",
            age: "Âge",
            building: "Bâtiment",
            milk: "Lait",
            calving: "Vêlage",
            insemination: "Insémination",
            action: "Action",
            by: "Par",
            for: "Depuis",
            ultrasound: "Ultrason",
            date: "Date",
            detail: "Détail",
            lactation: "Lactation",
            lastState: "Dernier état",
            sicknesses: "Maladies"
        },
        route: {
            dashboard: "Tableau de bord",
            fecondity: "Fécondité",
            cattle: "Troupeau",
            bull: "Taureau",
            buildings: "Bâtiments",
            animals: "Animaux",
            insemination: "Fécondité",
            milkInspection: "Contrôle laitier",
            log: "Journal",
            summary: "Synthèse",
            culled: "Réformés"
        },
        animal: {
            type: {
                calf: "Taurillon",
                heifer: "Génisse",
                cow: "Vache",
                bull: "Taureau"
            },
            state: {
                ultrasound: "A échographier",
                calving: "Vêlage",
                calved: "Vêlée",
                inseminate: "A inséminer",
                inseminated: "Gestante",
                insemination: "Insémination",
                'non-inseminated': "Non inséminée",
                cull: "Mise en réforme",
                culled: "Réformée",
                'to-dry-up': "A tarir",
                dried: "Târie",
                dead: "Morte",
                milkInspection: "Contrôle laiter",
                hot: "Vue en chaleur",
                nothing: "Rien",
                empty: "Vide",
                unknown: "Incertain",
                abortion: "Avortement",
                stillbirth: "Mort-née",
                'abortion-dead': "Avortement et mère morte",
                'stillbirth-dead': "Mort-née et mère morte",
                'abortion-but': "Avortement mais lactation",
                pregnant: "Pleine",
                monitor: "A surveiller",
                error: "Erreur",
                sold: "Vendu"
            }
        }
    }
}

export default basic